<app-menu-bar></app-menu-bar>

<div class="dashboard-page">
    <div class="dashboard-container">
        <app-admin-nav></app-admin-nav>

        <div id="messages">
            <div class="messages-head">
                <div class="text-area">
                    <span class="title">{{ 'messages_title' | translate }}</span>
                    <span class="subtitle">
                        @if (!loading) {
                            {{ 'messages_counts' | translate: { open: openCount, resolved: resolvedCount } }}
                        }
                    </span>
                </div>
                <div class="search">
                    <i class="fa-light fa-magnifying-glass" aria-hidden="true"></i>
                    <input type="text" [placeholder]="'messages_search_placeholder' | translate" autocomplete="off"
                        [(ngModel)]="search" />
                </div>
            </div>

            <div class="filter-tabs" role="tablist">
                <button type="button" role="tab" [class.active]="filter === 'open'" [attr.aria-selected]="filter === 'open'"
                    (click)="setFilter('open')">{{ 'messages_tab_open' | translate: { count: openCount } }}</button>
                <button type="button" role="tab" [class.active]="filter === 'resolved'" [attr.aria-selected]="filter === 'resolved'"
                    (click)="setFilter('resolved')">{{ 'messages_tab_resolved' | translate: { count: resolvedCount } }}</button>
                <button type="button" role="tab" [class.active]="filter === 'all'" [attr.aria-selected]="filter === 'all'"
                    (click)="setFilter('all')">{{ 'messages_tab_all' | translate: { count: messages.length } }}</button>
            </div>

            @if (loading) {
                <div class="loading-state">
                    <span class="spinner" role="status" [attr.aria-label]="'messages_loading_aria' | translate"></span>
                </div>
            } @else if (messages.length === 0) {
                <p class="state-text">{{ 'messages_empty' | translate }}</p>
            } @else if (filteredMessages.length === 0) {
                <p class="state-text">
                    @if (search.trim()) {
                        {{ 'messages_no_match' | translate: { search: search } }}
                    } @else if (filter === 'open') {
                        {{ 'messages_none_open' | translate }}
                    } @else {
                        {{ 'messages_none_resolved' | translate }}
                    }
                </p>
            } @else {
                <div class="message-list">
                    @for (m of filteredMessages; track m.id) {
                        <article class="message-card" [class.is-resolved]="m.resolved">
                            <div class="card-head">
                                <div class="who">
                                    <span class="avatar">{{ initials(m) }}</span>
                                    <div class="who-text">
                                        <span class="name">{{ m.name || ('messages_name_missing' | translate) }}</span>
                                        <span class="sent-at">{{ m.createdAt | customDate }}</span>
                                    </div>
                                </div>
                                <!-- Sits with the name: who wrote in and how to reach
                                     them read as one unit. -->
                                <div class="contact-pills">
                                    <a class="contact-pill" [href]="'mailto:' + m.email">
                                        <i class="fa-solid fa-envelope" aria-hidden="true"></i>
                                        <span class="contact-value">{{ m.email }}</span>
                                    </a>
                                    <a class="contact-pill" [href]="'tel:' + m.phoneNumber">
                                        <i class="fa-solid fa-phone" aria-hidden="true"></i>
                                        <span class="contact-value">{{ m.phoneNumber }}</span>
                                    </a>
                                </div>

                                <span class="badge" [class.resolved]="m.resolved">
                                    {{ (m.resolved ? 'messages_badge_resolved' : 'messages_badge_open') | translate }}
                                </span>
                            </div>

                            <div class="message-block">
                                <span class="block-label">{{ 'messages_block_label' | translate }}</span>
                                <p class="message-text">{{ m.message }}</p>
                            </div>

                            <div class="card-foot">
                                @if (m.resolved && m.resolvedByName) {
                                    <span class="resolved-by">{{ 'messages_resolved_by' | translate: { name: m.resolvedByName } }}</span>
                                }
                                <button type="button" class="resolve-btn" [class.reopen]="m.resolved"
                                    [disabled]="isSaving(m)" (click)="toggleResolved(m)">
                                    {{ (m.resolved ? 'messages_action_reopen' : 'messages_action_resolve') | translate }}
                                </button>
                            </div>
                        </article>
                    }
                </div>
            }
        </div>
    </div>
</div>

<app-footer></app-footer>
